(function imagesGalleryHandler() {
  'use strict';

  const firstImage = document.querySelector('[data-active-image]');
  if (!firstImage) {
    return;
  }

  /**
   * This function checks if the first image is in portrait orientation and adds
   * a specific class if it is.
   */
  function handlerVerticalImages() {
    const isPortraitImage = firstImage.naturalHeight > firstImage.naturalWidth;
    if (isPortraitImage) {
      firstImage.classList.add('nhs-c-image--vertical');
    }
  }

  if (firstImage.complete && firstImage.naturalHeight !== 0) {
    handlerVerticalImages();
    return;
  }

  firstImage.addEventListener('load', handlerVerticalImages);
}());
